import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function IntroSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  const line1 = "Cada espacio cuenta una historia.";
  const line2 = "Nosotros la diseñamos.";

  return (
    <section className="py-28 md:py-36 lg:py-44 px-6 md:px-12 lg:px-24 relative" data-testid="intro-section">
      {/* Subtle top line */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={inView ? { scaleX: 1 } : {}}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        className="absolute top-0 left-6 md:left-12 lg:left-24 right-6 md:right-12 lg:right-24 h-px bg-neutral-200 origin-left"
      />

      <div className="max-w-[1800px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-20 items-start">
          <div className="md:col-span-2">
            <motion.p
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : {}}
              transition={{ delay: 0.3 }}
              className="text-[11px] font-semibold uppercase tracking-[0.25em] text-neutral-400"
            >
              Filosofía
            </motion.p>
            <motion.div
              initial={{ scaleY: 0 }}
              animate={inView ? { scaleY: 1 } : {}}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="w-px h-16 bg-neutral-200 mt-4 origin-top hidden md:block"
            />
          </div>

          <div className="md:col-span-10" ref={ref}>
            <h2
              className="text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-normal text-neutral-900 tracking-tight leading-[1.08]"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {/* Line 1 — word by word reveal */}
              <span className="block overflow-hidden">
                {line1.split(" ").map((word, i) => (
                  <motion.span
                    key={i}
                    initial={{ opacity: 0, y: 50 }}
                    animate={inView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                    className="inline-block mr-[0.25em]"
                  >
                    {word}
                  </motion.span>
                ))}
              </span>
              {/* Line 2 — muted color */}
              <span className="block overflow-hidden mt-1">
                {line2.split(" ").map((word, i) => (
                  <motion.span
                    key={i}
                    initial={{ opacity: 0, y: 50 }}
                    animate={inView ? { opacity: 0.25, y: 0 } : {}}
                    transition={{ duration: 0.6, delay: 0.5 + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                    className="inline-block mr-[0.25em]"
                  >
                    {word}
                  </motion.span>
                ))}
              </span>
            </h2>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 1 }}
              className="mt-10 md:mt-14 text-lg md:text-xl font-light leading-relaxed text-neutral-500 max-w-2xl"
            >
              En <span className="text-neutral-800 font-normal">Merza Soluciones</span> transformamos 
              visiones en realidades tangibles. Desde el proyecto arquitectónico hasta la construcción final, 
              cada detalle está cuidadosamente pensado para crear espacios que inspiran.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}
